import { conversationsConstants } from '../../constants';

function setSocket(payload) {
  return { type: conversationsConstants.SET_SOCKET, payload };
}

function setConversations(payload) {
  return { type: conversationsConstants.CONVERSATIONS, payload };
}

function setConversation(payload) {
  return { type: conversationsConstants.SET_CONVERSATION, payload };
}

function setMessages(payload) {
  return { type: conversationsConstants.SET_MESSAGES, payload };
}

function setPost(payload) {
  return { type: conversationsConstants.SET_POST, payload };
}

function setPosts(payload) {
  return { type: conversationsConstants.SET_POSTS, payload };
}

function setReplies(payload) {
  return { type: conversationsConstants.SET_REPLIES, payload };
}

function setGlobalMessageCount(payload) {
  return { type: conversationsConstants.GLOBALCOUNT, payload };
}

function setConversationActiveTab(payload) {
  return { type: conversationsConstants.ACTIVETAB, payload };
}

function setPrePopulatedMessage(payload) {
  return { type: conversationsConstants.SET_PRE_POPULATED_MESSAGE, payload };
}

function setPinnedMessages(payload) {
  return { type: conversationsConstants.SET_PINNED_MESSAGES, payload };
}

function setLatestPinnedMessage(payload) {
  return { type: conversationsConstants.SET_LATEST_PINNED_MESSAGE, payload };
}

// payload: { chatId, isPinned } — toggles the pin status of a single message
// in the current conversation so mounted Message components re-render
function updateMessagePinnedStatus(payload) {
  return { type: conversationsConstants.UPDATE_MESSAGE_PINNED_STATUS, payload };
}

export const conversationsActions = {
  setSocket,
  setConversations,
  setConversation,
  setMessages,
  setPost,
  setPosts,
  setReplies,
  setGlobalMessageCount,
  setConversationActiveTab,
  setPrePopulatedMessage,
  setPinnedMessages,
  setLatestPinnedMessage,
  updateMessagePinnedStatus,
};
